import styles from './style.postcss';

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import is from 'is_js';
import { connect, HorizontalSelect, StudentCard } from 'omni-common-ui';
import { actions as GroupMembers } from 'data/GroupMembers';
import { actions as UiState } from 'data/UiState';

class StudentSelect extends PureComponent {
  constructor(props) {
    super(props);
    this._getLinkHrefForValue = (studentId) =>
      this.props.buildRoute({ studentId, mode: '' });
  }


  componentWillMount() {
    this._buildStudentSelectOptions();
  }

  componentWillReceiveProps(nextProps) {
    this._buildStudentSelectOptions(nextProps);
  }

  _buildStudentSelectOptions(props = this.props) {
    // cache the result
    if (is.existy(this._studentSelectOptions) &&
      is.existy(this._membersInCurrentProgressReport) &&
      this._membersInCurrentProgressReport === props.membersInCurrentProgressReport) {
      return;
    }
    const { membersInCurrentProgressReport } = props;
    if (membersInCurrentProgressReport && membersInCurrentProgressReport.size > 0) {
      // cache this - do not recreate each time
      this._membersInCurrentProgressReport = membersInCurrentProgressReport;
      this._studentSelectOptions = membersInCurrentProgressReport.map((option) => {
        const { studentGeneralInfo } = option;
        const optionHtml = <StudentCard vertical
            borderless
            backgroundless>
          <StudentCard.Profile name={studentGeneralInfo.firstName}
              surname={studentGeneralInfo.lastName}
              localName={studentGeneralInfo.localName}
              avatarUrl={studentGeneralInfo.avatarUrl}
              gender={studentGeneralInfo.gender} />
        </StudentCard>;
        return {
          html: optionHtml,
          value: studentGeneralInfo.id,
        };
      });
    }
  }

  render() {
    const { currentMember, membersInCurrentProgressReport, isHide } = this.props;
    if (currentMember &&
      membersInCurrentProgressReport.size &&
      membersInCurrentProgressReport.size > 0) {
      return <div className={styles.StudentSelect}>
        <HorizontalSelect options={this._studentSelectOptions}
            value={currentMember && currentMember.studentGeneralInfo.id}
            getLinkHrefForValue={this._getLinkHrefForValue}
            isHide={isHide} />
      </div>;
    }
    return null;
  }
}

function mapStateToProps(state, ownProps) {
  const { studentId, groupId, progressReportId } = ownProps.params;
  const studentReportSummaries =
    state.get('rootReducer').get('studentReportSummaries').get(progressReportId);
  if (studentReportSummaries && studentReportSummaries.data) {
    const studentReportSummariesStudentIds =
      studentReportSummaries.data.toList().map((srs) => srs.studentId);
    const membersInCurrentProgressReport = GroupMembers.getMembersByGroup(state, groupId)
      .filter(({ studentGeneralInfo: { id } }) =>
      studentReportSummariesStudentIds.indexOf(`${id}`) !== - 1);
    return {
      currentMember: GroupMembers.getMemberById(state, studentId),
      membersInCurrentProgressReport,
      isHide: ! UiState.getShowNavigationBar(state),
    };
  }
}

StudentSelect.propTypes = {
  currentMember: PropTypes.object,
  membersInCurrentProgressReport: PropTypes.object,
  buildRoute: PropTypes.func,
  isHide: PropTypes.bool,
};

export default connect(mapStateToProps, null)(StudentSelect);



// WEBPACK FOOTER //
// ./containers/Group/ProgressReport/StudentReportView/StudentSelect/index.jsx